import Loader from "react-loader-spinner";
import { useEffect, useRef, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { EyeFill, EyeSlashFill, FileEarmarkExcelFill, Printer, Search } from "react-bootstrap-icons";
import DatePicker from "react-datepicker2";
import { searchCallHistory } from "../store/api/CustomerApi";
import BihamtaTable from "../../Components/BihamtaTable";
import { exportToExcel } from "../../store/api/CommonFunctions";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";

const CallHistory = () => {
    const history = useHistory();
    const dispath = useDispatch();
    const { register, handleSubmit } = useForm();
    const [pending, setPending] = useState(false);
    const [showFilters, setShowFilters] = useState(true);
    const searchData = useRef({});
    function showHideFilter(hide) {
        const divFilters = document.getElementById("divFilters");
        if (hide) {
            divFilters.classList.add("hiddenRow");
            setShowFilters(false);
        }
        else {
            divFilters.classList.remove("hiddenRow");
            setShowFilters(true);
        }
    }
    function search(data) {
        if (!data.Take) {
            data.Take = 10;
        }
        data.Skip = 0;
        data.PCallDate = document.getElementsByName("CallDate")[0]?.value;
        if (data.PCallDate === "") {
            searchData.current.CallDate = null;
        }
        data.CallDate = searchData.current.CallDate;

        data.PToDate = document.getElementsByName("ToDate")[0]?.value;
        if (data.PToDate === "") {
            searchData.current.ToDate = null;
        }
        data.ToDate = searchData.current.ToDate;
        data.CallerType = " ";
        searchData.current = { ...data };
        dispath(searchCallHistory(data));
    }
    const tableCols = [
        { colTitle: "ردیف", colName: "RowNumber" },
        { colTitle: "نوع تماس گیرنده", colName: "PCallerType" },
        { colTitle: "تماس گیرنده", colName: "CallerName" },
        { colTitle: "کاربر داخلی", colName: "UserName" },
        { colTitle: "شماره تماس", colName: "CallNumber" },
        { colTitle: "تاریخ و ساعت تماس", colName: "PCallDate", style: { direction: "ltr" } },
        { colTitle: "تماس خروجی", colName: "IsOutgoingCall", colType: "boolean" },
        { colTitle: "از دست رفته", colName: "IsMissed", colType: "boolean" }
    ]
    function toExcel() {
        const url = "api/CRMReportsAPI/SearchCallHistory";
        const searchArgs = { ...searchData.current };
        searchArgs.Skip = 0;
        searchArgs.Take = 0;
        setPending(true);
        exportToExcel("CallHistory", searchArgs, url, "post", tableCols, () => setPending(false));
    }
    function print(e) {
        history.push({
            pathname: `/PrintViewer/CallHistory/${e.ctrlKey}`,
            state: {
                dataUrl: "api/CRMReportsAPI/SearchCallHistory",
                method: "post",
                fetchBody: JSON.stringify({ ...searchData.current, Take: 0, Skip: 0 })
            }
        });
    }
    function rowClick(row) {
        switch (row.CallerType) {
            case "staff":
                window.open(`/Services/AddEditStaff/false/${row.CallerID}`);
                break;
            case "agent":
                window.open(`/Services/AddEditStaff/true/${row.CallerID}`);
                break;
            case "customer":
                window.open(`/CRM/AddEditCustomer/${row.CallerID}`);
                break;
            case "precustomer":
                window.open(`/CRM/AddEditPreCustomer/${row.CallerID}`);
                break;
        }
    }
    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-مشتریان";
    }, [])
    return (
        <div className="container-fluid mt-2">
            <br />
            <Card className="card">
                <Card.Header className="headerStyle">تاریخچه تماس ها</Card.Header>
                <Card.Body className="bodyStyle" style={{ textAlign: "right" }}>
                    <form onSubmit={handleSubmit(search)}>
                        <Row id="divFilters" className="rowBorder">
                            <div className="rowTitle">
                                فیلترهای جستجو
                                &nbsp;
                                {showFilters && <EyeSlashFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(true)} />}
                                {!showFilters && <EyeFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(false)} />}
                            </div>
                            <Col md={2} className="form-group">
                                <label>از تاریخ: </label>
                                <DatePicker isGregorian={false} timePicker={false} className="search-input" name='CallDate'
                                    onChange={value => { searchData.current.CallDate = value.local("en").format("YYYY-MM-DD") }} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تا تاریخ: </label>
                                <DatePicker isGregorian={false} timePicker={false} className="search-input" name='ToDate'
                                    onChange={value => { searchData.current.ToDate = value.local("en").format("YYYY-MM-DD") }} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>شماره تماس: </label>
                                <input className="search-input" name="CallNumber" ref={register({})} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>نام تماس گیرنده: </label>
                                <input className="search-input" name="CallerName" ref={register({})} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>کاربر داخلی: </label>
                                <input className="search-input" name="UserName" ref={register({})} />
                            </Col>
                            <Col md={2} className="form-group" >
                                <label>وضعیت پاسخگویی</label>
                                <select className="search-input" name="IsMissed" defaultValue="" ref={register({})}>
                                    <option value="">انتخاب کنید</option>
                                    <option value={false}>پاسخ داده شده</option>
                                    <option value={true}>از دست رفته</option>
                                </select>
                            </Col>
                            <Col md={2} className="form-group">
                                <label>نوع تماس:</label>
                                <select className="search-input" name="IsOutgoingCall" ref={register({})} defaultValue="">
                                    <option value="">انتخاب کنید</option>
                                    <option value={false}>ورودی</option>
                                    <option value={true}>خروجی</option>
                                </select>
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تعداد در صفحه:</label>
                                <select className="search-input" onChange={e => searchData.current.Take = e.target.value} onKeyDown={search} defaultValue={10}>
                                    <option value={0}>تمام ردیفها</option>
                                    <option value={10}>10</option>
                                    <option value={20}>20</option>
                                    <option value={30}>130</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                    <option value={1000}>1000</option>
                                </select>
                            </Col>
                        </Row>
                        <Button type="submit" className="group-Btn-large mb-2 mt-1"><Search size={18} />&nbsp; جسـتجـو&nbsp;</Button>
                    </form>
                    {!pending && <div style={{ padding: 0, width: "100%", textAlign: "left" }}>
                        <FileEarmarkExcelFill onClick={toExcel} size={25} color="green" style={{ cursor: "pointer" }} className="hoverIcon" />
                        <Printer onClick={print} size={25} color="blue" style={{ cursor: "pointer" }} className="hoverIcon" />
                    </div>}
                    {pending && <div style={{ padding: 0, width: "100%", textAlign: "left" }}><Loader type="BallTriangle" color="#bb1370" height={18} style={{ textAlign: "left", alignItems: "left" }} /></div>}
                    <BihamtaTable columns={tableCols} reducerName="customerDataReducer" objectName="callHistory" hasPaging filterData={searchData.current}
                        searchMethod={(data) => dispath(searchCallHistory(data))} maxHeight={500} rowClick={rowClick} />
                </Card.Body>
            </Card>
        </div>
    )
}
export default CallHistory;